import classNames from 'classnames';
import React from 'react';
import { Typography, TypographyVariant } from '../typography/typography';
import styles from './series-number.module.scss';

type Props = {
  seriesNumber: string;
  seriesNumberColor: string | undefined;
  variant?: 'small' | 'big' | 'pageHeader';
};

export const SeriesNumber: React.FC<Props> = ({ seriesNumber, seriesNumberColor, variant = 'small' }) => {
  const fontVariant: TypographyVariant = variant === 'small' ? 'smalltext' : 'headline-3';
  const isBoldStyle = fontVariant === 'smalltext';

  return (
    <div
      className={classNames(styles.root, styles[variant])}
      style={{ '--igp-series-number-bg': seriesNumberColor ?? 'var(--igp-dark-night)' }}
    >
      <Typography color="white" fontStyle={isBoldStyle ? 'bold' : undefined} tag="span" variant={fontVariant}>
        {seriesNumber}
      </Typography>
    </div>
  );
};
